<div *ngIf="visible"
     id="featured-docs-section"
     class="overflow-restrictor clearfix"
     [ngClass]="{'wac-start-page-section width-restrictor width-restrictor--responsive': !fluentRefresh, 'wac-start-page-section--fluent width-restrictor--no-gutter': fluentRefresh}">
    <div class="wac-start-page-header">
        <h3 class="list-header__title wac-start-page-header__title ms-fcl-nd">{{ title }}</h3>
    </div>
    <div class="generic-tile-container featured-documents" [ngClass]="{'border-bottom' : featuredDocs?.length, 'generic-tile-container--fluent': fluentRefresh}" #featuredDocsElement>
        <ng-container *ngIf="featuredDocs?.length">
            <div *ngFor="let featuredDoc of featuredDocs | slice:0:(isCollapsedView ? maxItemsPerLine : featuredDocs.length); trackBy: trackByIndex" class="featured-document" [ngClass]="'featured-document-n' + maxItemsPerLine">
                <a [attr.href]="featuredDoc.Url"
                   [attr.target]="defaultLinkTarget"
                   class="generic-tile template-tile"
                   [ngClass]="(fluentRefresh ? 'ms-fcl-nd ms-bgc-nlh-h ms-bgc-nlp-a ' : 'template-tile--legacy ms-fcl-np ms-fcl-tda-h ms-fcl-tda-f ms-bgc-nl-h ms-bgc-g40-f ms-bgc-g40-a ') + 'template-tile--small template-tile--small--' + appName"
                   (click)="onDocumentClick(featuredDoc)"
                   [title]="featuredDoc.Title"
                   [attr.aria-label]="featuredDoc.Title"
                   data-clicklog="custom">
                    <div class="generic-tile__images_container">
                        <div class="generic-tile__images">
                            <img *ngIf="featuredDoc.Thumbnail"
                                 [src]="featuredDoc.Thumbnail"
                                 [ngClass]="'generic-tile__thumbnail generic-tile__thumbnail--' + appName"
                                 alt="{{ featuredDoc.Title }}" />
                        </div>
                    </div>
                    <div class="template__title template__title--small">{{ featuredDoc.Title }}</div>
                </a>
            </div>
        </ng-container>
    </div>
    <span *ngIf="isError || isLoading" class="featured-documents-loading-error border-bottom">
        <ohp-alert-message *ngIf="isError" [message]="errorMessage"></ohp-alert-message>
        <div *ngIf="isLoading" class="featured-documents-loading-error-spinner ms-Spinner-circle ms-Spinner--medium"></div>
    </span>
    <ohp-title-announcer *ngIf="featuredDocs && featuredDocs.length" [announcement]="stateAnnouncement"></ohp-title-announcer>
    <button *ngIf="featuredDocs && featuredDocs.length > maxItemsPerLine" class="see-more-items"
        id="showMoreFeaturedDocumentsId"
        (click)="toggle()"
        [attr.aria-label]="isCollapsedView ? showMoreAriaLabel : showLessAriaLabel"
        role="button"
        data-clicklog="custom">
        <div class="flex-container">
            <span [attr.data-alt]="isCollapsedView ? showMoreText : showLessText">{{ isCollapsedView ? showMoreText : showLessText }}</span>
            <ohp-icon-font [iconFontName]="isCollapsedView ? 'ChevronDown' : 'ChevronUp'"
                            cssClass="see-more-items__icon--fluent"
                            size="8">
            </ohp-icon-font>
        </div>
    </button>
</div>
